import { useState } from "react";
import { ChevronDown, CircleHelp } from "lucide-react";
import SectionHeading from "../SectionHeading";
import { faqs } from "../../data/siteContent";

export default function FAQSection() {
  const [open, setOpen] = useState(0);
  return (
    <section className="section-space bg-mist">
      <div className="container grid gap-12 lg:grid-cols-[.65fr_1.35fr]">
        <div>
          <div className="grid h-16 w-16 place-items-center rounded-2xl bg-ink text-cyan">
            <CircleHelp />
          </div>
          <SectionHeading
            eyebrow="Questions welcome"
            title="No black boxes."
            copy="We will always explain the scope, next step and what we need from you."
          />
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={faq.question}
              className="rounded-2xl border border-ink/10 bg-white"
            >
              <button
                type="button"
                onClick={() => setOpen(open === index ? -1 : index)}
                className="flex w-full items-center justify-between gap-5 p-5 text-left font-display font-bold text-ink"
              >
                <span>{faq.question}</span>
                <ChevronDown
                  size={18}
                  className={`shrink-0 text-ocean transition ${open === index ? "rotate-180" : ""}`}
                />
              </button>
              {open === index && (
                <p className="px-5 pb-5 text-sm leading-7 text-slate">
                  {faq.answer}
                </p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
